import { render, staticRenderFns } from "./TestLayoutView.vue?vue&type=template&id=5df341ef"
import script from "./TestLayoutView.vue?vue&type=script&lang=ts"
export * from "./TestLayoutView.vue?vue&type=script&lang=ts"
import style0 from "./TestLayoutView.vue?vue&type=style&index=0&id=5df341ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports